import React from "react";

const Secondary = () => {
  return (
    <>
      <span className="badge-outline">secondary</span>
    </>
  );
};
export default Secondary;
